import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

export const CIE_10 = {
  id: 'admin.khuyana.cie',
  title: 'Administración de CIE',

  labels: {
    ...COMMONS,
    upload: 'Cargar CIE',
    template: 'Plantilla',
    edit: 'Editar CIE',
    publishYear: 'Año de publicación',
    description: COMMONS.longDescription,
    displayName: COMMONS.shortDescription,
    saveSuccess: 'Se cargó el archivo exitosamente!'
  },

  actions: {
    ...ACTIONS,
    download: 'Descargar plantilla',
  }

};
